//実績表示component
import React, {Component} from 'react';
import ToggleDisplay from 'react-toggle-display';


export default class GetUserRecord extends Component {
	constructor (props) {
		super(props)
		this.state = {
			state: {...props.state}
		}
	}

	componentWillReceiveProps = (state) => {
		this.setState({state:{...state.state}})
	}

	render () {
		const {
			state
		} = this.state
		return (
          <div className="block-icon-achievement">

            <div className="icon-achievement">
              <img alt="" className="icon" src="/img/common/icon_fb.png" />
              <div className="popup popup_1">
                <p className="popup-title">Facebook</p>
                <div className="line-dashed"></div>
                <div className="text-left popup-content">
                  <img alt="" className="icon-check" src="/img/common/img_check_purple.png" />
                  <span>FB連携済み</span>
                </div>
              </div>
            </div>

            <div className="icon-achievement">
              <img alt="" className="icon" src="/img/common/icon_tel2.png" />
              <div className="popup popup_2">
                <p className="popup-title">SMS</p>
                <div className="line-dashed"></div>
                <div className="text-left popup-content">
                  <img alt="" className="icon-check" src="/img/common/img_check_purple.png" />
                  <span>電話番号認証済み</span>
                </div>
              </div>
            </div>

            <ToggleDisplay if={state.id_on}>
            <div className="icon-achievement">
              <img alt="" className="icon" src="/img/common/icon_id.png" />
              <div className="popup popup_3">
                <p className="popup-title">ID</p>
                <div className="line-dashed"></div>
                <div className="text-left popup-content">
                  <img alt="" className="icon-check" src="/img/common/img_check_purple.png" />
                  <span>本人確認済み</span>
                </div>
              </div>
            </div>
            </ToggleDisplay>

            <ToggleDisplay if={state.yahooauction_on}>
            <div className="icon-achievement">
              <img alt="" className="icon" src="/img/common/icon_yahooauction.png" />
              <div className={"popup popup_" + state.yahooauction_popup_count}>
                <p className="popup-title">ヤフオク!</p>
                <div className="line-dashed"></div>
                {state.yahoo_auction.map(item =>
                <div className="text-left popup-content" key={item}>
                  <img alt="" className="icon-check" src="/img/common/img_check_purple.png" />
                  <span>{item}</span>
                </div>
                )}
              </div>
            </div>
            </ToggleDisplay>


            <ToggleDisplay if={state.coconala_on}>
            <div className="icon-achievement">
              <img alt="" className="icon" src="/img/icons/icon_coconala.png" />
              <div className={"popup popup_" + state.coconala_popup_count}>
                <p className="popup-title">ココナラ</p>
                <div className="line-dashed"></div>
                {state.coconala.map(item =>
                <div className="text-left popup-content" key={item}>
                  <img alt="" className="icon-check" src="/img/common/img_check_purple.png" />
                  <span>{item}</span>
                </div>
                )}
              </div>
            </div>
            </ToggleDisplay>


            <ToggleDisplay if={state.anyca_on}>
            <div className="icon-achievement">
              <img alt="" className="icon" src="/img/icons/icon_anyca.png" />
              <div className={"popup popup_" + state.anyca_popup_count}>
                <p className="popup-title">Anyca</p>
                <div className="line-dashed"></div>
                {state.anyca.map(item =>
                <div className="text-left popup-content" key={item}>
                  <img alt="" className="icon-check" src="/img/common/img_check_purple.png" />
                  <span>{item}</span>
                </div>
                )}
              </div>
            </div>
            </ToggleDisplay>


            <ToggleDisplay if={state.notteco_on}>
            <div className="icon-achievement">
              <img alt="" className="icon" src="/img/icons/icon_notteco.png" />
              <div className={"popup popup_" + state.notteco_popup_count}>
                <p className="popup-title">notteco</p>
                <div className="line-dashed"></div>
                {state.notteco.map(item =>
                <div className="text-left popup-content" key={item}>
                  <img alt="" className="icon-check" src="/img/common/img_check_purple.png" />
                  <span>{item}</span>
                </div>
                )}
              </div>
            </div>
            </ToggleDisplay>


            <ToggleDisplay if={state.spacemarket_on}>
            <div className="icon-achievement">
              <img alt="" className="icon" src="/img/icons/icon_spacemarket.png" />
              <div className={"popup popup_" + state.spacemarket_popup_count}>
                <p className="popup-title">スペースマーケット</p>
                <div className="line-dashed"></div>
                {state.spacemarket.map(item =>
                <div className="text-left popup-content" key={item}>
                  <img alt="" className="icon-check" src="/img/common/img_check_purple.png" />
                  <span>{item}</span>
                </div>
                )}
              </div>
            </div>
            </ToggleDisplay>

            {/* 20180425 rakuma
            <ToggleDisplay if={state.rakuma_on}>
            <div className="icon-achievement">
              <img alt="" className="icon" src="/img/icons/icon_rakuma.png" />
              <div className={"popup popup_" + state.rakuma_popup_count}>
                <p className="popup-title">ラクマ</p>
                <div className="line-dashed"></div>
                {state.rakuma.map(item =>
                <div className="text-left popup-content" key={item}>
                  <img alt="" className="icon-check" src="/img/common/img_check_purple.png" />
                  <span>{item}</span>
                </div>
                )}
              </div>
            </div>
            </ToggleDisplay> */}

            {/* 20180514 minne */}
            <ToggleDisplay if={state.minne_on}>
            <div className="icon-achievement">
              <img alt="" className="icon" src="/img/icons/icon_minne.png" />
              <div className={"popup popup_" + state.minne_popup_count}>
                <p className="popup-title">minne</p>
                <div className="line-dashed"></div>
                {state.minne.map(item =>
                <div className="text-left popup-content" key={item}>
                  <img alt="" className="icon-check" src="/img/common/img_check_purple.png" />
                  <span>{item}</span>
                </div>
                )}
              </div>
            </div>
            </ToggleDisplay> 

            <ToggleDisplay if={state.isLogin && state.isMylisence}>
            <div className="icon-achievement">
              <img alt="" className="icon" src="/img/common/icon_add.png" data-modaltype="1" onClick={this.props.openModal}/>
            </div>
            </ToggleDisplay>
          </div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/GetUserRecord.js